import React, {Component} from "react"
import PropTypes from "prop-types"

import notify from "@irati/utils/notify"
import getMessage from "@irati/utils/lang/helpers/getMessage"
import {injectIntl} from "@irati/utils/lang"
import {updateSchedule} from "@irati/insights/services/schedule"
import {DELETED} from "@irati/insights/constants/schedule"
import {Para} from "@irati/ui/src/Labels"
import id from "@irati/utils/id"

import Modal from "../../../ui/Modal/Modal"

class Delete extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      loading: false
    }
  }

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  handleAction = () => {
    this.openModal()
  }

  openModal = () => {
    this.setState({show: true})
  }

  closeModal = () => {
    this.setState({show: false})
  }

  handleConfirm = () => {
    this.setState({loading: true})
    return updateSchedule({...this.props.schedule, status: DELETED})
      .then(() => {
        this.setState({loading: false, show: false})
        this.props.onChange()
        notify.light({
          message: getMessage(this, "insights.homepage.deleteModal.successMessage"),
          status: "success",
          position: "top-right"
        })
      })
      .catch((error) => {
        this.setState({loading: false})
        notify.light({
          message: getMessage(this, error.contentKey),
          status: "error",
          position: "top-right"
        })
      })
  }

  render() {
    const {show, loading} = this.state
    return (
      <Modal
        id={id("Modal", this.props)}
        primary={{
          text: getMessage(this, "insights.homepage.deleteModal.primaryButton"),
          onClick: this.handleConfirm
        }}
        secondary={{
          text: getMessage(this, "insights.homepage.actions.closeLabel"),
          onClick: this.closeModal
        }}
        show={show}
        loading={loading}
        handleClose={this.closeModal}
        title={getMessage(this, "insights.homepage.deleteModal.title")}>
        <Para>{getMessage(this, "insights.homepage.deleteModal.text")}</Para>
      </Modal>
    )
  }
}

export default injectIntl(Delete, {withRef: true})
